import React from "react";
import { connect } from "react-redux";
import { Typography, Button, Grid } from "@material-ui/core";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
import blankProfile from "./DefaultProfile";
import {
    getRequesting,
    selectProfile,
    selectToolType,
    getUserIcons,
    selectCurrentUser,
    selectNewToolboxID,
} from "./selectors";

import {
    AttachedImages,
    GeneralDetails,
    TalkingPoints,
    ToolboxReports,
} from "./Widgets";
import {
    getToolBox,
    setToolbox,
    getToolBoxTypes,
    uploadFile,
    getNewToolboxID,
} from "./actions";
import { Modal, ModalBody, Spinner } from "reactstrap";

class ToolBoxtalklist extends React.Component {
    constructor(props) {
        super(props);
        let profile = blankProfile;
        let pageType = props.match.params.type;
        let toolbox_id = "";
        if (pageType === "new") {
            props.getNewToolboxID();
        } else {
            toolbox_id = props.match.params.uid;
        }

        this.state = {
            pageType: props.match.params.type,
            toolbox: { profile },
            toolbox_id,
        };
        props.getToolBoxTypes();
        if (pageType !== "new") props.getToolBox(toolbox_id);
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.pageType !== "new" &&
            this.props.toolbox !== this.state.toolbox
        ) {
            this.setState({ toolbox: this.props.toolbox });
        }
        if (
            this.props.newToolboxID !== this.state.toolbox_id &&
            this.state.pageType === "new"
        ) {
            let tools = this.state.toolbox;
            tools.profile.toolbox_id = this.props.newToolboxID;
            this.setState({
                toolbox: tools,
                toolbox_id: this.props.newToolboxID,
            });
        }
        if (this.state.toolbox) {
            if (
                this.state.toolbox.profile.created_by === false &&
                this.props.created_by !== false
            ) {
                let tools = this.state.toolbox;
                tools.profile.created_by = this.props.created_by;
                this.setState({ toolbox: tools });
            }
        }
    }
    render() {
        const {
            toolbox: { profile = false, reports = false, points = [] } = false,
            toolbox,
        } = this.state;

        return (
            <StyledCard style={{ paddingBottom: "0px" }}>
                <React.Fragment>
                    <StyledHeader>
                        <Typography variant="h5">
                            ToolBox Profile -{" "}
                            {this.state.toolbox_id !== ""
                                ? this.state.toolbox_id
                                : "N/A"}
                        </Typography>
                    </StyledHeader>
                    <br />
                    <StyledContent style={{ paddingTop: "0px" }}>
                        <Modal
                            isOpen={this.props.requesting}
                            style={{ maxWidth: "00px" }}
                        >
                            <ModalBody>
                                <div
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "3em",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "white",
                                            width: "fit-content",
                                            display: "inline-block",
                                            padding: "2em",
                                        }}
                                    >
                                        <Spinner
                                            style={{
                                                height: 100,
                                                width: 100,
                                                background: "white",
                                            }}
                                            color="primary"
                                        />
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                marginTop: 15,
                                                color: "rgba(0, 0, 0, 0.87)",
                                                fontWeight: "bolder",
                                                fontSize: 20,
                                            }}
                                            variant="body2"
                                        >
                                            Processing...
                                        </Typography>
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>

                        <StyledViewContainer style={{ paddingTop: "0px" }}>
                            <Grid container spacing={16}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={6}
                                >
                                    <Grid container spacing={8}>
                                        <GeneralDetails
                                            pageType={this.state.pageType}
                                            profile={profile}
                                            toolboxTypes={
                                                this.props.toolboxTypes
                                            }
                                            setData={(key, value) => {
                                                let tools = toolbox;
                                                tools.profile[key] = value;
                                                this.setState({
                                                    toolbox: tools,
                                                });
                                            }}
                                        />
                                        <AttachedImages
                                            pageType={this.state.pageType}
                                            profile={profile}
                                            uploadFile={this.props.uploadFile}
                                            setData={(key, value) => {
                                                let tools = toolbox;
                                                tools.profile[key] = value;
                                                this.setState({
                                                    toolbox: tools,
                                                });
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={6}
                                >
                                    <TalkingPoints
                                        pageType={this.state.pageType}
                                        points={points}
                                        setData={(items) => {
                                            let tools = toolbox;
                                            tools.points = items;
                                            this.setState({
                                                toolbox: tools,
                                            });
                                        }}
                                    />
                                </Grid>
                                {this.state.pageType === "view" && (
                                    <ToolboxReports
                                        toolbox_id={this.state.toolbox_id}
                                        reports={reports}
                                        userIcons={this.props.userIcons}
                                    />
                                )}
                            </Grid>
                            {this.state.pageType !== "view" && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.props.setToolbox(
                                            this.state.toolbox
                                        );
                                        this.props.history.goBack();
                                    }}
                                    style={{
                                        marginBottom: 24,

                                        color: "white",
                                        background: "#0188cc",
                                    }}
                                >
                                    Submit
                                </Button>
                            )}
                            {this.state.pageType !== "view" && (
                                <Button
                                    variant="contained"
                                    color="default"
                                    onClick={() => {
                                        this.props.history.goBack();
                                    }}
                                    style={{ marginLeft: 24, marginBottom: 24 }}
                                >
                                    Cancel
                                </Button>
                            )}
                        </StyledViewContainer>
                    </StyledContent>
                </React.Fragment>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            newToolboxID: selectNewToolboxID(store),
            requesting: getRequesting(store),
            toolbox: selectProfile(store),
            toolboxTypes: selectToolType(store),
            userIcons: getUserIcons(store),
            created_by: selectCurrentUser(store),
        };
    },
    {
        uploadFile,
        getNewToolboxID,
        getToolBox,
        setToolbox,
        getToolBoxTypes,
    }
)(ToolBoxtalklist);
